import React from "react";
import { IoTodayOutline, IoChevronUpOutline, IoChevronDownOutline } from "react-icons/io5";

const TodayOrdersBanner = ({ count = 0, active = false, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`sq-today-banner ${active ? "sq-today-banner-active" : ""}`}
    >
      <div className="sq-today-banner-left">
        <div className={`sq-today-badge ${active ? "sq-today-badge-active" : ""}`}>
          <IoTodayOutline size={16} color={active ? "#fff" : "#075E54"} />
        </div>

        <div className="sq-today-banner-texts">
          <div className="sq-today-title">
            Bugünkü sifarişlərin sayı: <span className="sq-today-count">{count}</span>
          </div>

          <div className="sq-today-sub">
            {active
              ? "Yalnız Bugün göstərilir — toxun, hamısını göstər"
              : "Toxun → Bugünün sifarişlərini aç"}
          </div>
        </div>
      </div>

      <div className="sq-today-chevron">
        {active ? (
          <IoChevronUpOutline size={20} color="#6B7280" />
        ) : (
          <IoChevronDownOutline size={20} color="#6B7280" />
        )}
      </div>
    </button>
  );
};

export default TodayOrdersBanner;